import { createOrUpdateLabels } from './search_boxes_labels';

// Function to handle the creation of inputs and label text based on URL parameters
export function searchBoxesInputs() {
    const searchBoxesContainer = document.querySelector('.festi-search-boxes-inputs');

    // Check if the searchBoxesContainer exists
    if (!searchBoxesContainer) {
        console.log('IGNORED searchBoxesContainer.');
        return;
    }


    const urlParams = new URLSearchParams(window.location.search);
    const lastValueMap = new Map();

    const excludedParams = new Set([
        "number_of_items_per_page", "page", "controller",
        "sort", "direction", "table", "alpha_sort", "compound_sort",
        "utf8", "authenticity_token", "action", "no_text", "_method", "geolocations",
        "", "reset_password_token", "show_details", "show_extra_details"
    ]);

    // Create a map to store the last value of each parameter
    for (let [key, value] of urlParams) {
        if (!excludedParams.has(key)) {
            lastValueMap.set(key, value);
        }
    }

    // Add only the last value of each parameter to the summary and create inputs
    for (let [key, value] of lastValueMap) {
        let found = false;
        const searchBoxes = document.querySelectorAll('.festi-search-boxes-inputs input[type="text"]');
        searchBoxes.forEach(function(input) {
            if (input.name === key) {
                found = true;
            }
        });

        if (!found) {
            // Create a 'row' div
            const rowDiv = document.createElement('div');
            rowDiv.className = 'row';

            // Create and add the input element
            const inputElement = document.createElement('input');
            inputElement.type = 'text';
            inputElement.name = key;
            inputElement.value = value;
            inputElement.placeholder = key.charAt(0).toUpperCase() + key.slice(1);
            inputElement.className = 'form-control search-box search-box-applied-important';

            if (value) {
                inputElement.classList.add('search-boxes-applied'); // Add the class if the input has a value
            }

            // Append the input element to the 'row' div
            rowDiv.appendChild(inputElement);

            // Append the 'row' div to the searchBoxesContainer
            searchBoxesContainer.appendChild(rowDiv);
        }
    }

    // Iterate over all existing inputs and update their label text
    const existingInputs = searchBoxesContainer.querySelectorAll('input[type="text"]');
    existingInputs.forEach(input => {
        const key = input.name;
        if (input.value) {
            input.classList.add('search-box-applied-important');
            createOrUpdateLabels(input, key);
        } else {
            input.classList.remove('search-box-applied-important');
        }

        // Add event listener to update label, style, and input value when input value changes
        input.addEventListener('input', function() {
            if (this.value) {
                this.classList.add('search-box-applied-important');
                createOrUpdateLabels(this, this.name);
            } else {
                this.classList.remove('search-box-applied-important');
            }
        });
    });
};
